import { render } from "./BackButton.vue?vue&type=template&id=28cfe078&scoped=true"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"

import "./BackButton.vue?vue&type=style&index=0&id=28cfe078&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-28cfe078"

export default script